<template>
  <div>
    <div class="checklist">
      <a-button icon="file-text" class="btn-green" @click="scenesList"
        >场景需求清单</a-button
      >
    </div>
    <div class="my-fabang-body">
      <a-table
        :columns="columns"
        :data-source="data"
        :pagination="pages"
        @change="tablePage"
      >
        <div slot="sceneName" slot-scope="text, record">
          <div class="fabang-title-body">
            <span
              ><images
                :id="
                  record.coverAttachment
                    ? record.coverAttachment.attachmentId
                    : ''
                "
            /></span>
            <div>
              <strong>{{ record.sceneName }}</strong>
              <p>
                <span>{{ record.fieldLevelOneName }}</span>
                <span>{{ record.industryLevelOneName }}</span>
              </p>
            </div>
          </div>
        </div>
        <div slot="ownerName" slot-scope="text">
          <div class="jiebang-unit">
            <p>{{ text }}</p>
          </div>
        </div>
        <div slot="fundAmount" slot-scope="text">￥{{ text }}</div>
        <div slot="statusName" slot-scope="text, record">
          <span class="my-scenes-status">
            <i v-if="record.statusName == '揭榜中'" class="sqz"></i>
            <i v-else-if="record.statusName == '已定帅'" class="yzb"></i>
            <i v-else-if="record.statusName == '未中榜'" class="wzb"></i>
            {{ record.statusName }}
          </span>
        </div>
        <div slot="operating" slot-scope="text, record">
          <div class="my-scenes-operating">
            <span @click="scenesDetail(record.id)">详情</span>
          </div>
        </div>
      </a-table>
    </div>
  </div>
</template>

<script>
const columns = [
  {
    title: "榜单信息",
    dataIndex: "sceneName",
    key: "sceneName",
    ellipsis: true,
    width: 420,
    scopedSlots: { customRender: "sceneName" },
  },
  {
    title: "发布单位",
    dataIndex: "ownerName",
    key: "ownerName",
    ellipsis: true,
    width: 220,
    scopedSlots: { customRender: "ownerName" },
  },
  {
    title: "发布时间",
    dataIndex: "previewTime",
    key: "previewTime",
  },
  // {
  //   title: "意向金额(万元)",
  //   dataIndex: "fundAmount",
  //   key: "fundAmount",
  //   scopedSlots: { customRender: "fundAmount" },
  // },
  {
    title: "申请截止时间",
    dataIndex: "applyDueDate",
    key: "applyDueDate",
  },
  {
    title: "状态",
    dataIndex: "statusName",
    key: "statusName",
    scopedSlots: { customRender: "statusName" },
  },
  {
    title: "操作",
    dataIndex: "operating",
    key: "operating",
    scopedSlots: { customRender: "operating" },
  },
];

import { getBidScene } from "@/api/scene";
import images from "@/page/components/image";
export default {
  components: {
    images,
  },
  data() {
    return {
      data: [],
      columns,
      pages: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        showTotal: (total) => `共 ${total} 项`,
      },
      page: {
        current: 1,
        size: 10,
      },
    };
  },
  mounted() {
    this.loadGetBidScene();
  },
  methods: {
    loadGetBidScene() {
      getBidScene(this.page).then((res) => {
        this.data = res.data.records;
        this.pages.total = res.data.total;
      });
    },
    tablePage(page) {
      this.page.current = page.current;
      this.loadGetBidScene();
    },
    scenesDetail(id) {
      this.$router.push({
        path: "/homeScenes/detail",
        query: { id: id },
      });
    },
    scenesList() {
      this.$router.push("/homeScenes/historyList");
    },
  },
};
</script>

<style lang="less" scoped>
.checklist {
  width: 1240px;
  margin: 0 auto 24px;
  text-align: right;
}
.my-fabang-body {
  width: 1240px;
  margin: 0 auto;
  background: #fff;
}
.fabang-title-body {
  display: flex;
  > span {
    width: 140px;
    max-height: 80px;
    margin-right: 16px;
    > img {
      display: block;
      max-width: 100%;
      max-height: 100%;
    }
  }
  > div {
    flex: 1;
    > strong {
      color: #262626;
      font-size: 16px;
      display: block;
      line-height: 16px;
      margin-bottom: 16px;
      max-width: 230px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    > p {
      display: flex;
      flex-wrap: wrap;
      > span {
        height: 22px;
        border: 1px solid #d9d9d9;
        border-radius: 2px;
        line-height: 20px;
        padding: 0 8px;
        margin-right: 8px;
      }
    }
  }
}
.jiebang-unit {
  display: flex;
  align-items: center;
  > span {
    width: 24px;
    height: 24px;
    margin-right: 8px;
    > img {
      max-width: 100%;
      max-height: 100%;
      display: block;
    }
  }
  > p {
    flex: 1;
  }
}
.my-scenes-operating {
  display: flex;
  > span {
    cursor: pointer;
    margin-right: 24px;
    color: #1abc9c;
    &:last-child {
      margin-right: 0;
    }
  }
}
.my-scenes-status {
  display: flex;
  align-items: center;
  > i {
    width: 6px;
    height: 6px;
    background: #bfbfbf;
    border-radius: 50%;
    margin-right: 8px;
    &.sqz {
      background: #faad14;
    }
    &.yzb {
      background: #52c41a;
    }
    &.wzb {
      background: #ff4d4f;
    }
  }
}
</style>
<style>
.my-fabang-body th,
.my-fabang-body td {
  border-color: #f0f0f0 !important;
}
.ant-table-pagination.ant-pagination {
  margin: 16px;
}
</style>
